import { useMutationDeleteSessionPackSubscriptionBySubscriptionId } from "@gymflow/api";
import { ToastContext } from "apps/portal/src/providers/ToastProvider/context";
import useGymflowModels from "apps/portal/src/store";
import { isAxiosError } from "axios";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ConfirmModal } from "../../../templates";

type ExpireCreditPackModalProps = {
  hide: () => void;
  subscriptionId: number;
  userMemberId: string;
};

export const ExpireCreditPackModal = ({
  hide,
  subscriptionId,
  userMemberId,
}: ExpireCreditPackModalProps) => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { notifyDanger, toast } = useContext(ToastContext);

  const {
    mutateAsync: mutateAsyncDeleteSessionPackSubscriptionBySubscriptionId,
  } = useMutationDeleteSessionPackSubscriptionBySubscriptionId({
    api,
  });

  const onConfirm = useCallback(async () => {
    try {
      await mutateAsyncDeleteSessionPackSubscriptionBySubscriptionId({
        subscriptionId,
        userMemberId,
      });
      toast({
        message: t(
          "components.creditPackItem.toasts.creditPackSuccessfullyUpdated",
        ),
      });
      hide();
    } catch (e) {
      if (isAxiosError(e)) {
        notifyDanger(e);
      }
    }
  }, [
    hide,
    mutateAsyncDeleteSessionPackSubscriptionBySubscriptionId,
    notifyDanger,
    subscriptionId,
    t,
    toast,
    userMemberId,
  ]);

  return (
    <ConfirmModal
      title={t("components.creditPackItem.modal.expireCreditPackModal.title")}
      type="danger"
      confirmText={t(
        "components.creditPackItem.modal.expireCreditPackModal.confirmText",
      )}
      onCancel={() => hide()}
      onConfirm={async () => await onConfirm()}
    >
      {t("components.creditPackItem.modal.expireCreditPackModal.description")}
    </ConfirmModal>
  );
};
